// Radha — supabase-js's functions.invoke() throws a generic "Edge Function
// returned a non-2xx status code" for ANY non-2xx response, discarding the
// function's own `{ error: "..." }` JSON body. That body is still readable
// from `error.context` (the raw, unconsumed fetch Response — supabase-js
// throws FunctionsHttpError before ever reading it), so this unwraps it once
// instead of every call site reporting the same useless generic message.
export async function edgeFunctionErrorMessage(error: unknown): Promise<string> {
  const context = (error as { context?: Response } | null)?.context;
  if (context && typeof context.json === "function") {
    try {
      const body = await context.json();
      if (body?.error) return String(body.error);
    } catch {
      // non-JSON or already-consumed body — fall through to the generic message
    }
  }
  return error instanceof Error ? error.message : String(error);
}
